var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 7.5C11.25 7.15482 11.5298 6.875 11.875 6.875H16.25C16.5952 6.875 16.875 7.15482 16.875 7.5C16.875 7.84518 16.5952 8.125 16.25 8.125H11.875C11.5298 8.125 11.25 7.84518 11.25 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 12.5C11.25 12.1548 11.5298 11.875 11.875 11.875H16.25C16.5952 11.875 16.875 12.1548 16.875 12.5C16.875 12.8452 16.5952 13.125 16.25 13.125H11.875C11.5298 13.125 11.25 12.8452 11.25 12.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74112 2.24112C4.97554 2.0067 5.29348 1.875 5.625 1.875H15.625C15.9565 1.875 16.2745 2.0067 16.5089 2.24112C16.7433 2.47554 16.875 2.79348 16.875 3.125V16.875C16.875 17.2065 16.7433 17.5245 16.5089 17.7589C16.2745 17.9933 15.9565 18.125 15.625 18.125H5.625C5.29348 18.125 4.97554 17.9933 4.74112 17.7589C4.5067 17.5245 4.375 17.2065 4.375 16.875V14.375C4.375 14.0298 4.65482 13.75 5 13.75C5.34518 13.75 5.625 14.0298 5.625 14.375V16.875H15.625V3.125L5.625 3.125L5.625 5.625C5.625 5.97018 5.34518 6.25 5 6.25C4.65482 6.25 4.375 5.97018 4.375 5.625V3.125C4.375 2.79348 4.5067 2.47554 4.74112 2.24112Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 13.75C10.9702 13.75 11.25 14.0298 11.25 14.375V17.5C11.25 17.8452 10.9702 18.125 10.625 18.125C10.2798 18.125 10 17.8452 10 17.5V14.375C10 14.0298 10.2798 13.75 10.625 13.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 1.875C10.9702 1.875 11.25 2.15482 11.25 2.5V5.625C11.25 5.97018 10.9702 6.25 10.625 6.25C10.2798 6.25 10 5.97018 10 5.625V2.5C10 2.15482 10.2798 1.875 10.625 1.875Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 6.25C1.875 5.55964 2.43464 5 3.125 5H11.25C11.9404 5 12.5 5.55964 12.5 6.25V13.75C12.5 14.4404 11.9404 15 11.25 15H3.125C2.43464 15 1.875 14.4404 1.875 13.75V6.25ZM11.25 6.25H3.125V13.75H11.25V6.25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40629 7.62504C5.68243 7.41793 6.07418 7.47389 6.28129 7.75004L9.09379 11.5C9.30089 11.7762 9.24493 12.1679 8.96879 12.375C8.69264 12.5821 8.30089 12.5262 8.09379 12.25L5.28129 8.50004C5.07418 8.22389 5.13014 7.83214 5.40629 7.62504Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96879 7.62504C9.24493 7.83214 9.30089 8.22389 9.09379 8.50004L6.28129 12.25C6.07418 12.5262 5.68243 12.5821 5.40629 12.375C5.13014 12.1679 5.07418 11.7762 5.28129 11.5L8.09379 7.75004C8.30089 7.47389 8.69264 7.41793 8.96879 7.62504Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5977bcf13e78d7e3e22cec8800625d27.svg";
export { ForwardRef as ReactComponent };